module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAYUlEQVR42mNgQAKrz1b8JxczUAOMOgDZwJ1PCWNcDvifKTmwDhiQEAD5mmyfjzpg1AHD3gFEO2xIhwBViuxRB1DiAKrUGaMOoJcDcGbX0SgYdcCoA0YdMOqAQeUAWmF0OwFCBv99DVXrqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/activas_pluri_sin.png
// module id = 1B5L
// module chunks = 0